import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import styles from "./index.module.scss";
import { ApiClient } from "/api/client";

export default function Manager({ productId, product }) {
  const [managerComment, setManagerComment] = useState("");
  const [managerDataNew, setManagerDataNew] = useState("");

  const { user } = useSelector((state) => state.user);
  const router = useRouter();
  useEffect(() => {
    if (user.IS_MANAGER || user.IS_ADMIN || Boolean(router.query.isManager)) {
      const id = productId;
      const getComments = async () => {
        const comment = await ApiClient.manager.getManagerComments([id]);
        setManagerComment(comment?.[id]);
      };
      const getDataNew = async () => {
        const managerData = await ApiClient.manager.getManagerDelivery(
          [id],
          router.query.time,
          router.query.weekday,
        );
        setManagerDataNew(managerData?.[id]);
      };

      getComments();
      getDataNew();
    }
  }, [user, productId, product]);

  return (
    <>
      {Boolean(managerComment) && (
        <p
          style={{ color: "red" }}
          dangerouslySetInnerHTML={{ __html: managerComment }}
        ></p>
      )}
      {Boolean(managerDataNew) && (
        <div
          className={styles.ManagerData}
          dangerouslySetInnerHTML={{ __html: managerDataNew }}
        />
      )}
    </>
  );
}
